export default __webpack_public_path__ + "static/media/google-logo.0ea06ee7.png";